export const ADD_TO_CART: String = "ADD_TO_CART"
export const REMOVE_FROM_CART: String = "REMOVE_FROM_CART"
export const CART_RESET: String = "CART_RESET"
export const CART_SAVE_SHIPPING_ADDRESS = 'CART_SAVE_SHIPPING_ADDRESS'
